import type { InferOutput, PicklistOptions, PicklistSchema } from 'valibot'
import { picklist, object, string, array, fallback, nullish, pipe, email, literal, union } from 'valibot'
import { orgNoSchema } from '#shared/organization-number'

export const coreApiSchema = picklist([
  'external',
  'ecommerce',
])

export type CoreApi = InferOutput<typeof coreApiSchema>

export const orgSchema = object({
  name: string(),
  number: orgNoSchema,
})

export type CoreOrganization = InferOutput<typeof orgSchema>

export const roleSchema = picklist([
  'student',
  'teacher',
])

export type CoreRole = InferOutput<typeof roleSchema>

export function safeEnum<TOptions extends PicklistOptions, const TSchema extends PicklistSchema<TOptions, undefined>>(schema: TSchema) {
  return fallback(union([schema, literal('UNKNOWN')]), 'UNKNOWN')
}

export const sourceSchema = picklist([
  'LOCAL',
  'FEIDE',
  'VIPPS',
  'COGNITO',
  'AZURE',
])

export type CoreSource = InferOutput<typeof sourceSchema>

export const userSchema = object({
  userId: string(),
  firstName: nullish(string()),
  lastName: nullish(string()),
  fullName: nullish(string()),
  source: safeEnum(sourceSchema),
  username: string(),
  role: fallback(array(roleSchema), []),
  email: fallback(
    nullish(
      pipe(
        string(),
        email(),
      ),
    ),
    null,
  ),
  homeOrganization: nullish(orgSchema),
  schoolOrganizations: fallback(array(orgSchema), []),

  // There is quite some more fields here, but none we care about
})

export type SessionUserInfoDto = InferOutput<typeof userSchema>

export const licensedProductSchema = object({
  ean: string(),
  name: string(),
  startDate: string(),
  endDate: nullish(string()),
  licenseModel: picklist([
    'OPEN',
    'SCHOOL',
    'INDIVIDUAL',
    'ORGANIZATIONAL',
    'PRIVATE',
    'TRIAL_SCHOOL',
  ]),
  // This contains a bunch of other fields we don't care about. Check the docs for details.
})

export type LicensedProduct = InferOutput<typeof licensedProductSchema>